import { createContext } from 'react';

export const OpenAlexContext = createContext<string | undefined>(undefined);
